import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TrialBalanceReportLine  {
    _originalTypeClassName = "zERP.BO.TrialBalanceReportLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TrialBalanceReportLine.translate = translateService;
}
this.Id = null;
this.PeriodD = null;
this.PeriodC = null;
this.OpeningD = null;
this.OpeningC = null;
this.Debit = null;
this.Credit = null;
this.ProgressD = null;
this.ProgressC = null;
this.BalanceD = null;
this.BalanceC = null;
this.Code = null;
this.Description = null;
this.Level = null;
this.GroupByField = null;
this.Expanded = false;
this.ParentId = null;
this.HasChildren = false;
this.IsHidden = false;
this.key = null;
this.TrialBalanceReportLineKey = null;
this._key = this.TrialBalanceReportLineKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
PeriodD:any;
PeriodC:any;
OpeningD:any;
OpeningC:any;
Debit:any;
Credit:any;
ProgressD:any;
ProgressC:any;
BalanceD:any;
BalanceC:any;
Code:any;
Description:any;
Level:any;
GroupByField:any;
Expanded:any;
ParentId:any;
HasChildren:any;
IsHidden:any;
key:any;
private _TrialBalanceReportLineKey:any;
get TrialBalanceReportLineKey(): any {
    return this._TrialBalanceReportLineKey;
  }
set TrialBalanceReportLineKey(value: any) {
    this._TrialBalanceReportLineKey = value;
    this._key = value;
  }

static HideChildren($this: any, lines: any,hide: any): any{let children = lines?.linq?.where((l) => CLMS.Framework.Number.Equal(() => l.ParentId, () => $this.Id))?.toArray();
for (let _ichild = 0; _ichild < (children == null ? 0 : children.length); _ichild++) {let child = children[_ichild];child.IsHidden = hide;Domain.TrialBalanceReportLine.HideChildren(child, lines, hide || $this?.Expanded == false);}
}
static ToggleExpand($this: any, lines: any): any{$this.Expanded = !($this?.Expanded);
Domain.TrialBalanceReportLine.HideChildren($this, lines, $this?.Expanded == false);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TrialBalanceReportLineKey == null || $this.TrialBalanceReportLineKey == 0;
            }


}